import {
  GET_DADOS_USUARIO,
  USUARIO_SET_COR_FAVORITA,
} from "../actions/usuario-actions";

//
function salvarCor(cor) {
  const storage = window?.localStorage;
  if (storage) {
    storage.setItem("_APP_COR_SECUNDARIA", cor);
  }
}

const userReducer = (state = null, action) => {
  switch (action.type) {
    case GET_DADOS_USUARIO:
      return {
        ...action.data,
      };
    case USUARIO_SET_COR_FAVORITA: // Define a cor favoria
      salvarCor(action.data);

      return {
        ...state,
        corSecundaria: action.data,
      };
    default:
      return state;
  }
};

export default userReducer;
